import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import jwtDecode from 'jwt-decode';
import analyticsService from '../utils/analytics';

import DownloadBtn from '../components/DownloadBtn';
import PassDetails from '../components/PassDetails';
// import Randomstring from 'randomstring';
// import jwt from 'jsonwebtoken';
// import { saveAs } from 'file-saver';

const useStyles = makeStyles(() => ({
   landingPage: {
      margin: '0 20px'
   }
}));

function Home(props) {
   const classes = useStyles();

   const [passData, setPassData] = useState(null);
   let navigate = useNavigate();
   const [token, setToken] = useState();

   useEffect(() => {
      let digitalData = analyticsService.getDigitalData();
      digitalData['page_name'] = "Home page";

      const deriveChannel = (cid) => {
         if (cid) {
            if (cid.split("_")[0].toLowerCase() == 'sms') {
               return "SMS";
            } else if (cid.split("_")[0].toLowerCase() == 'e') {
               return "Email";
            } else {
               return "";
            }
         } else {
            return "SMS";
         }
      }

      /* Fetching pass token from URL */
      const queryParams = new URLSearchParams(window.location.search);
      const queryToken = queryParams.get("data");
      setToken(queryToken);
      if (queryToken) {
         try {
            const decodedToken = jwtDecode(queryToken);
            setPassData(decodedToken);

            digitalData['brand_name'] = decodedToken.product;
            digitalData['cid'] = decodedToken.cid;
            digitalData['member_id'] = decodedToken.member_id;
            digitalData['customer_id'] = decodedToken.customerID;
            digitalData['tc'] = decodedToken.tc;
            digitalData['channel'] = deriveChannel(decodedToken.cid);
         } catch (err) {
            navigate(`/error`, { state: { error_type: 'invalid_token' } });
         }
      } else if (queryToken == '') {
         navigate(`/error`, { state: { error_type: 'invalid_token' } });
      }
      analyticsService.setDigitalData(digitalData);

   }, [])

   // const onClicked = () => {
   //    let urlArray = [];
   //    for (let i = 0; i < 1000; i++) {
   //       let x = 100000 + i;
   //       const pass_data = {
   //          product: 'Sotyktu',
   //          member_id: x
   //       }
   //       const token = jwt.sign(pass_data, 'Mz7eDxNZq0xiATNUlUotqTa0dwnflfQW');
   //       urlArray[i] = token + '\n';
   //    }
   //    var file = new Blob(urlArray, { type: "text/csv;charset=utf-8" });
   //    saveAs(file, "walletURLs.csv");
   // }

   return (
      <div className={classes.landingPage}>
         {token ?
            <div>
               <PassDetails platform={props.platform} passname={passData && passData.product} passData={passData} />
               <DownloadBtn platform={props.platform} passname={passData && passData.product} passData={passData} token={token} />
            </div>
            :
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: '50px' }}>
               <h1 className=''>Wallet CoPay</h1>
               <p>Navigate to the Wallet email or SMS on your mobile device and follow the steps mentioned to add the Co-Pay Pass to your Wallet.</p>
            </div>
         }
         {/* <button onClick={onClicked}>Test</button> */}
      </div>
   );
}

export default Home;
